import { render, staticRenderFns } from "./ConnectToWalletButton.vue?vue&type=template&id=0a1b89c7&"
import script from "./ConnectToWalletButton.vue?vue&type=script&lang=js&"
export * from "./ConnectToWalletButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports